<template>
<div class="p-25">
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ad</label>
            <input type="text" class="form-control" v-model="value.Name" placeholder="Ad" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Grup</label>
            <v-select-list v-model="group" label="Name" placeholder="Grup" :options="groups"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Çarpan</label>
            <input type="text" class="form-control" v-model="value.Multiplier" placeholder="Çarpan" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control" v-model="value.Description" placeholder="Açıklama" />
        </div>
    </div>
</div>
</template>

<script>
import {BFormCheckbox,BInputGroup,BFormInput,BInputGroupAppend,BTabs,BTab} from 'bootstrap-vue'
import HRParametersApi from '@/api/human-resources-parameters'

export default {
    components: {
        BFormCheckbox,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BTabs,
        BTab
    },
    props:{
        value:Object
    },
    data(){
        return {
            groups:[],
        }
    },
    watch:{
    },
    mounted(){
        this.getGroups()
    },
    methods: {
        getGroups(){
            HRParametersApi.AdministrativeLevelGroup.List().then(res=>{
                this.groups = res.data.Data
            })
        }
    },
    computed:{
        group:{
            get:function(){
                return this.groups.find(b=>b.Id==this.value.AdministrativeLevelGroupId)
            },
            set:function(value){
                this.value.AdministrativeLevelGroupId = value?.Id || null
            }
        }
    }
}
</script>

<style>
.custom-nav .nav-link{
    margin: 0.25rem;
}
.custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 85%);
    background-color: #ffffff;
}

.dark-layout .custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 40%);
    background-color: #283046;
}
</style>